// src/components/auth/AuthLayout.jsx
export default function AuthLayout({ children, topLogo }) {
  return (
    <div className="min-h-screen w-full relative bg-[#f4fbf6] flex flex-col overflow-hidden">
      
      {/* PREMIUM LIGHT MESH BACKGROUND */}
      <div className="absolute top-0 left-0 w-full h-[60vh] overflow-hidden bg-gradient-to-b from-white to-[#e6f4ea]">
        
        {/* Soft floating orbs for depth */}
        <div className="absolute -top-[10%] -right-[10%] w-[60%] h-[60%] rounded-full bg-[#bbf7d0] blur-[90px] opacity-60" />
        <div className="absolute top-[20%] -left-[15%] w-[50%] h-[50%] rounded-full bg-[#86efac] blur-[100px] opacity-40" />

        {/* Centered Logo with a soft glow */}
        <div className="absolute inset-0 flex items-center justify-center pb-16">
          <div className="absolute w-[200px] h-[200px] bg-white rounded-full blur-[60px] opacity-80" />
          {topLogo && (
            <div className="relative z-10 animate-in fade-in zoom-in duration-700 ease-out">
              <img 
                src={topLogo} 
                alt="Warranty Mitra Logo" 
                className="max-w-[260px] sm:max-w-[300px] object-contain drop-shadow-[0_8px_16px_rgba(22,163,74,0.12)]" 
              />
            </div>
          )}
        </div>
      </div>

      {/* BOTTOM 40% FORM AREA */}
      <div className="relative z-20 flex-1 flex flex-col justify-end pt-[40vh] max-w-md mx-auto w-full">
        {children}
      </div>
    </div>
  );
}
//**************************************************chetan code *************************************************************** */
// // src/components/auth/AuthLayout.jsx
// import { motion } from "framer-motion";

// export default function AuthLayout({
//   children,
//   showIllustration = true,
// }) {
//   return (
//     <div className="
//       min-h-screen w-full relative overflow-hidden
//       bg-gradient-to-br from-[#F8FAFF] via-[#EAF1FF] to-[#D6E4FF]
//       flex items-center justify-center p-3
//     ">

//       {/* BLURRED BACKGROUND SHAPES */}
//       <div className="absolute -top-40 -left-40 w-[420px] h-[420px] bg-[#A9C8FF] rounded-full blur-[140px] opacity-50" />
//       <div className="absolute top-1/4 -right-48 w-[520px] h-[520px] bg-[#0A5BFF] rounded-full blur-[180px] opacity-30 " />
//       <div className="absolute bottom-0 left-1/4 w-[420px] h-[420px] bg-[#0B2E6F] rounded-full blur-[180px] opacity-25" />


//       {/* CENTERED CARD CONTAINER */}
//       <div className="
//         relative z-10
//         w-full max-w-6xl
//         flex
//         items-center justify-center
//         min-h-[600px]
//       ">


//         {/* LEFT ILLUSTRATION */}
//         {/* {showIllustration && (
//           <div className="hidden lg:flex w-1/2 items-center justify-center">
//             <motion.img
//               src={require("../../images/login.webp")}
//               alt="Login Illustration"
//               initial={{ opacity: 0, x: -40 }}
//               animate={{ opacity: 1, x: 0 }}
//               transition={{ duration: 0.5 }}
//               className="max-w-[420px] w-full"
//             />
//           </div>
//         )} */}

//         {/* RIGHT CONTENT */}
//         <div className="w-full lg:w-1/2 flex items-center justify-center">
//           {children}
//         </div>

//       </div>
//     </div>
//   );
// }


/************************************************************************************************************************* */
// // components/auth/AuthLayout.jsx
// import { motion } from "framer-motion";

// export default function AuthLayout({ children, showIllustration = true }) {
//   return (
//     <div className="min-h-screen relative flex overflow-hidden bg-gradient-to-br from-blue-100 via-indigo-100 to-purple-100">

//       {/* Decorative blobs */}
//       <div className="absolute -top-20 -left-20 w-72 h-72 bg-blue-400 rounded-full blur-3xl opacity-30" />
//       <div className="absolute top-1/3 -right-24 w-96 h-96 bg-indigo-400 rounded-full blur-3xl opacity-30" />
//       <div className="absolute bottom-0 left-1/4 w-80 h-80 bg-purple-400 rounded-full blur-3xl opacity-30" />

//       {/* Illustration */}
//       {showIllustration && (
//         <div className="hidden lg:flex w-1/2 items-center justify-center p-10">
//           <motion.img
//             src={require("../../asset/images/login.webp")}
//             alt="Auth Illustration"
//             initial={{ opacity: 0, x: -40 }}
//             animate={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.5 }}
//             className="max-w-md w-full max-h-96"
//           />
//         </div>
//       )}

//       {/* Content */}
//       <div className="w-full lg:w-1/2 flex items-center justify-center px-4">
//         {children}
//       </div>
//     </div>
//   );
// }
